export default __webpack_public_path__ + "static/media/shape-2.f2d172ea.svg";